import { useFetchUser } from "@/entities/user";
import { useLoadingAppStore } from "@/shared/model";
import { Header } from "@/widgets/header";
import { Spinner } from "react-bootstrap";
import { useLocation, Outlet } from "react-router-dom";

export const Layout: React.FC = () => {
  useFetchUser();
  const { isLoading } = useLoadingAppStore();

  return (
    <>
      <Header />
      <main>
        {isLoading ? (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(255, 255, 255, 0.6)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <Spinner
              animation="border"
              variant="secondary"
              style={{ width: 50, height: 50 }}
            />
          </div>
        ) : (
          <Outlet />
        )}
      </main>
    </>
  );
};
